// extracted by mini-css-extract-plugin
module.exports = {"root":"AgreementModal_root__c5mTn","additionalInfo":"AgreementModal_additionalInfo__1nfNY"};